module.exports = __webpack_public_path__ + "img/remate.b0599190.jpg";